import { Injectable } from '@angular/core';
import { fromJS } from 'immutable';
import { extend, isArray, map, reduce } from 'lodash';
import { TrackingEvent } from './models/tracking-event.model';
import {
  IAnalyticsOptions,
  ITrackingAction,
  ITrackingObject,
  ITrackingProperties,
} from './models/tracking.data';

@Injectable()
export class I2gNgTrackingBuilder {
  constructor() {}

  buildContext(options: IAnalyticsOptions, traits?: ITrackingProperties) {
    return {
      context: {
        app: {
          version: options.app_version,
          name: options.app_name,
        },
        traits,
      },
    };
  }

  buildTrackingEvent(
    trackingObjects: ITrackingObject | ITrackingObject[],
    trackingAction: ITrackingAction,
    additionalProperties?: any
  ): TrackingEvent {
    const trackingObjectsName = isArray(trackingObjects)
      ? map(trackingObjects, (trackingObject) => trackingObject.name).join('_')
      : (trackingObjects as ITrackingObject).name;

    const trackingObjectsProperties = isArray(trackingObjects)
      ? reduce(
          trackingObjects,
          (result, trackingObject) => {
            extend(result, trackingObject.properties);

            return result;
          },
          {}
        )
      : (trackingObjects as ITrackingObject).properties;

    const trackingEventProps = fromJS({
      [TrackingEvent.KEYS.NAME]: [trackingObjectsName, trackingAction.name].join('_'),
      [TrackingEvent.KEYS.PROPERTIES]: extend(
        {},
        trackingObjectsProperties,
        trackingAction.properties,
        additionalProperties
      ),
    });

    return new TrackingEvent(trackingEventProps);
  }
}
